import { privacyPolicy } from '@hb/shared'
import { LegalDocumentView } from './LegalDocument'

export const PrivacyPolicyView = () => <LegalDocumentView document={privacyPolicy} />
